import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Form, Button, message, Layout, Space, Divider } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";

//component
import RegisterLogo from "./component/register_logo";
import RegisterName from "./component/register_name";
import RegisterIRD from "./component/register_ird";
import RegisterFirstName from "./component/register_first_name";
import RegisterLastName from "./component/register_last_name";
import RegisterPhone from "./component/register_phone";
import RegisterEmail from "./component/register_email";
import RegisterAdress from "./component/register_address";
import RegisterAdressSuburb from "./component/register_address_suburb";
import RegisterAdressCity from "./component/register_address_city";
import RegisterAdressState from "./component/register_address_state";
import RegisterAdressPostCode from "./component/register_address_post_code";
import RegisterPassword from "./component/register_password";
import RegisterPasswordConfirm from "./component/register_password_confirm";
import { MODEL_REGISTER } from "../../model/register";

import { useMenu } from "../../hook/useMenu";
import { registerEmailPassword } from "../../store/auth/auth.action";
import { addOwnerInfo } from "../../store/role/role.action";
import { addUserInfo } from "../../store/user/user.action";

import "./style.css";

const { Content } = Layout;

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 16,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 8,
    offset: 0,
  },
};

const buttonCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 20,
    offset: 8,
  },
};

const RegisterScreen = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const breadCrumb = [
    { title: "Home", url: "/" },
    { title: "Register", url: "/register" },
  ];
  const { t } = useTranslation("translation", { keyPrefix: "register" });
  const navigate = useNavigate();
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const onSelectLogo = (uri) => {
    setLogo(uri);
    form.setFieldsValue({ logo: uri });
  };

  const onSelectAddress = (values) => {
    form.setFieldsValue(values);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    form.setFieldsValue(MODEL_REGISTER);
  }, [form]);
  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    const register = {
      ...values,
    };

    console.log({ register });
    delete register.confirm;
    setLoading(true);
    dispatch(
      // register
      registerEmailPassword({ register }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Register Successfully");
          dispatch(addUserInfo({ user: register }));
          dispatch(addOwnerInfo({ user: register }));
        }
        if (response?.status === 500) {
          const error = response.data;
          message.error(error);
        }
      })
    );
  };

  const onFinishFailed = (error) => {
    console.log({ error });
  };

  // -------------------------- RENDER --------------------------

  const renderRegisterForm = () => {
    const disabled = loading;
    return (
      <Form
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        name="register_form"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 5]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <RegisterLogo
              disabled={disabled}
              logo={logo}
              onSelect={onSelectLogo}
            />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterIRD disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterFirstName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterLastName disabled={disabled} />
          </Col>

          <Col xl={12} lg={12} md={12} xs={24}>
            <RegisterAdress disabled={disabled} onSelect={onSelectAddress} />
          </Col>

          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterAdressSuburb disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterAdressCity disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterAdressState disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterAdressPostCode disabled={disabled} />
          </Col>
          <Divider />
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterEmail disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterPassword disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterPhone disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <RegisterPasswordConfirm disabled={disabled} />
          </Col>
          <Col
            align="right"
            style={{ margin: "40px 0px 60px" }}
            xl={24}
            lg={24}
            md={24}
            xs={24}
          >
            <Space>
              <Button
                style={{ width: 100 }}
                onClick={() => navigate("/")}
                type="default"
              >
                Back
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                style={{ width: 100 }}
                loading={loading}
              >
                {t("register")}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full register-screen">
      <Content className="content">
        <Row align="center">
          <Col xxl={20} xl={20} lg={20} md={20} xs={24}>
            <Row style={{ marginTop: 40 }} gutter={[16, 16]} align="center">
              <Col align="center" xl={24} lg={24} md={24} xs={24}>
                <h1
                  style={{
                    fontSize: 30,
                    fontWeight: 600,
                  }}
                >
                  Register Owner Account
                </h1>
                <LayoutBreadCrumb data={breadCrumb} />
              </Col>
              <Col xl={24} lg={24} md={24} xs={24}>
                {renderRegisterForm()}
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default RegisterScreen;
